import { css } from '@linaria/core';

export const popupCurtainClass = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
`;

export const sidePanelPopupClass = css`
    position: absolute;
    top: 71px;
    right: 5px;
    width: 500px;
    height: 660px;
    background: white;
    box-shadow: 0 2px 6px 2px #ddd;
    z-index: 1000;
    overflow-y: auto;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 500px;
    }

    @media (max-width: 480px) {
        width: 100%;
    }
`;

export const popupHeaderClass = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #e65100;
    color: #fff;
    padding: 0.6rem 1rem 0.5rem 1rem;
    border-bottom: none;
    position: relative;

    h2 {
        margin: 0;
        color: #fff;
        font-size: 1.15rem;
        font-weight: 400;
        flex-grow: 1;
    }
`;

export const closeButtonClass = css`
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #fff;
    padding: 0.5rem;
    border-radius: 4px;
    transition: all 0.3s;
    margin: 0;
    line-height: 1;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: #fff;
    }
`;

export const popupContentClass = css`
    padding: 1.5rem;

    h2 {
        margin: 0 0 1.5rem 0;
        color: #333;
        font-size: 1.5rem;
        font-weight: 600;
    }

    h3 {
        margin: 0 0 1rem 0;
        color: #495057;
        font-size: 1.2rem;
        font-weight: 600;
    }

    @media (max-width: 480px) {
        padding: 1rem;
    }
`;

export const userInfoPanelClass = css``;

export const profileSectionClass = css`
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #e9ecef;
`;

export const userAvatarClass = css`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: 1rem;
    border: 2px solid #dee2e6;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 600;
    text-transform: uppercase;
`;

export const userDetailsClass = css`
    h4 {
        margin: 0 0 0.5rem 0;
        color: #333;
        font-size: 1.1rem;
        font-weight: 600;
    }

    p {
        margin: 0 0 0.25rem 0;
        color: #6c757d;
        font-size: 0.9rem;
    }
`;

export const appInfoClass = css`
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #e9ecef;

    h3 {
        color: #333;
        font-size: 1.1rem;
        margin-bottom: 1rem;
    }

    p {
        margin: 0 0 0.5rem 0;
        color: #6c757d;
        font-size: 0.9rem;
    }
`;

export const logoutSectionClass = css`
    margin-top: 2rem;
`;

export const logoutClass = css`
    padding: 0.6rem 1.5rem;
    background: #12427d;
    border-radius: 4px;
    border: 0;
    color: #fff;
    font-size: 0.95rem;
    font-weight: 500;
    outline: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
    width: 100%;

    &:hover {
        background: #0d3461;
    }

    &:active {
        background: #082542;
    }
`;

export const appsContentClass = css``;

export const appsGridClass = css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
`;

export const appCardClass = css`
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
`;

export const appIconClass = css`
    font-size: 2rem;
    margin-bottom: 0.5rem;
    color: #667eea;
`;

export const appNameClass = css`
    font-weight: 600;
    color: #333;
    margin: 0;
    font-size: 0.9rem;
`;

// User account styling
export const userAccountSectionClass = css`
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e9ecef;
`;

export const userAccountNameClass = css`
    font-weight: 600;
    color: #333;
    font-size: 1rem;
    margin: 0 0 0.25rem 0;
`;

export const userAccountEmailClass = css`
    color: #6c757d;
    font-size: 0.85rem;
    margin: 0;
`;

// User roles styling
export const loadingRolesClass = css`
    text-align: center;
    padding: 1rem;
    color: #666;

    p {
        margin: 0;
    }
`;

export const userRolesSectionClass = css`
    margin-bottom: 1rem;

    h4 {
        color: #333;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
`;

export const rolesContainerClass = css`
    padding-left: 0.5rem;
`;

export const roleItemContainerClass = css`
    margin-bottom: 0.25rem;
    padding: 0.35rem 0.5rem;
    background: #f8f9fa;
    border-radius: 3px;
    border-left: 2px solid #0066cc;
`;

export const roleNameSpanClass = css`
    font-weight: 500;
    color: #333;
    font-size: 0.8rem;
    display: block;
`;

export const roleDescriptionSpanClass = css`
    font-size: 0.85rem;
    color: #666;
    margin-top: 0.25rem;
    display: block;
`;

export const permissionsSectionClass = css`
    margin-bottom: 1.5rem;

    h4 {
        color: #333;
        margin-bottom: 0.5rem;
        font-size: 1rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    p {
        padding-left: 1rem;
        color: #666;
        margin: 0.25rem 0;
    }
`;